const ProductSection = ({ title, subtitle, image }) => {
    return (
      <section className="py-20 bg-white text-center">
        <h2 className="mt-6 text-4xl font-semibold">{title}</h2>
        <p className="text-lg mt-2">{subtitle}</p>
        <img src={image} alt={title} className="rounded-full w-4/5 mx-auto mt-4" />
      </section>
    );
  };
  
  export default ProductSection;